import { render, staticRenderFns } from "./FilesUploadManager.vue?vue&type=template&id=83d296d2"
import script from "./FilesUploadManager.vue?vue&type=script&lang=js"
export * from "./FilesUploadManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports